import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { WebhookIntegrationRecord } from "../WebhookIntegrationRecord";

interface UpdateWebhookIntegrationSecretParams {
  webhookEndpointId: string;
  webhookSecret: string;
}

export function useUpdateWebhookIntegrationSecret() {
  const { integrationService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    WebhookIntegrationRecord,
    Error,
    UpdateWebhookIntegrationSecretParams
  >({
    mutationFn: ({ webhookEndpointId, webhookSecret }) => {
      return integrationService
        .updateWebhookIntegrationSecret(webhookEndpointId, webhookSecret)
        .then((response) => {
          queryClient.setQueryData(
            ["webhookEndpointId", response.webhook_endpoint_id],
            response,
          );
          return response;
        });
    },
  });
}
